import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import TopBar from './TopBar';


interface LayoutProps {
  children: ReactNode;
  userName?: string;
  onMenuClick?: () => void;
}

const Layout = ({ children, userName, onMenuClick }: LayoutProps) => {
  const host = typeof window !== 'undefined' ? window.location.hostname.toLowerCase() : '';
  const isDevEnvironment = import.meta.env.MODE === 'development' || host.includes('dev') || host.includes('develop');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' , marginTop: '0px'}}>
      <TopBar userName={userName} onMenuClick={onMenuClick} />
      {isDevEnvironment && (
        <Box
          sx={{
            width: '100%',
            backgroundColor: '#14803C',
            color: '#FFFFFF',
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, minmax(0, 1fr))' },
            alignItems: 'center',
            minHeight: { xs: 30, sm: 34, md: 40 },
            px: { xs: 1, sm: 1.5 },
            boxSizing: 'border-box',
          }}
        >
          <Box sx={{ textAlign: 'left', fontSize: { xs: 14, sm: 18, md: 24 }, fontWeight: 500, lineHeight: 1, display: { xs: 'none', sm: 'block' } }}>Dev Environment</Box>
          <Box sx={{ textAlign: 'center', fontSize: { xs: 14, sm: 18, md: 24 }, fontWeight: 500, lineHeight: 1 }}>Dev Environment</Box>
          <Box sx={{ textAlign: 'right', fontSize: { xs: 14, sm: 18, md: 24 }, fontWeight: 500, lineHeight: 1, display: { xs: 'none', sm: 'block' } }}>Dev Environment</Box>
        </Box>
      )}
        <Box component="main" sx={{ flexGrow: 1, bgcolor: 'white', background: '#F3F3F3', display: 'flex', flexDirection: 'column', overflow: 'auto', minHeight: 0 }}>
            {children}
        </Box>
    </Box>
  );
};

export default Layout;
